// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"82":"3e6c4c87","735":"c04eb95f","808":"4829edfe","974":"69cfe7df","985":"b1c00b28"}[chunkId] + ".css";
};